import React from 'react';
import { Popup, Icon } from 'semantic-ui-react';

class HelpButton extends React.Component {

  render() {
    
    return(
      <Popup trigger={<Icon name='question circle' color="grey" className='labelIcon'/>} position='right center'>
      <Popup.Content>
        <div dangerouslySetInnerHTML={{ __html: this.props.hint}} />
      </Popup.Content>
      </Popup>
    )
  }

}

export default HelpButton;